module.exports = __webpack_public_path__ + "static/media/yanga.b888ae2a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/yanga.webp
// module id = 509
// module chunks = 0